import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import CompWrapper from './func';
import { Routes } from '../../util/router/routes';
import './index.less';
import MyHeader from './header';
import MyFooter from './footer';
import { URL_USE, URL_RULE } from '../../config';
import { actUI } from '../../redux/action/ui';

const { Header, Content, Footer } = Layout;
let homeCookieFlag = true;
let ifEmptyFooterHeader = true;
export class App extends Component {
  // export const App = (props) => {
  componentDidMount() {
    const { dispatch } = this.props;

    const homeUrl = window.location.href;
    console.log(`======mm==${homeUrl}`);
    if (homeUrl.indexOf('/rule') > 0 || homeUrl.indexOf('/useus') > 0 || homeUrl.indexOf('/404') > 0) {
      ifEmptyFooterHeader = false;
    } else {
      ifEmptyFooterHeader = true;
    }

    const homeCookieMsg = document.cookie;
    if (homeCookieMsg.indexOf('homeCookieFlag=true') !== -1) {
      homeCookieFlag = false;
    } else {
      homeCookieFlag = true;
    }
    actUI(dispatch, {
      uiLogin: {
        cookieVisibility: true,
        messageVisiable: true,
        uiForm: { cookieEditable: true, cookieEnable: true },
      },
    });
  }

  handleClickClose = () => {
    homeCookieFlag = false;
    document.cookie = 'homeCookieFlag=true';
    const { dispatch } = this.props;
    actUI(dispatch, { uiLogin: { messageVisiable: false } });
  }

  handleClickOK = () => {
    const { dispatch } = this.props;
    actUI(dispatch, {
      uiLogin: { cookieVisibility: false },
    });
  }

  handleNoticeClick = () => {
    const { dispatch } = this.props;
    actUI(dispatch, {
      uiIndex: { uiHeader: { uiMenuNotice: { dialogState: true } } },
    });
  }

  render() {
    const {
      className,
      filePath,
      auth,
      user,
      handleLogout,
      updateUser,
      changeLanguage,
      ui,
      routes,
      dispatch,
    } = this.props;

    return (
      <Layout className={className + filePath}>
        {ifEmptyFooterHeader && (
        <Header className="header">
          <MyHeader
            auth={auth}
            user={user}
            handleLogout={handleLogout}
            updateUser={updateUser}
            changeLanguage={changeLanguage}
            changePwd={updateUser}
            ui={ui.uiHeader}
            dispatch={dispatch}
            handleNoticeClick={this.handleNoticeClick}
          />
        </Header>
        )}
        <div className="acceptBarCon">
          {ifEmptyFooterHeader && homeCookieFlag && (
            <div className="acceptBar">
              <FormattedMessage
                id="Home.acceptCookieMsg"
                defaultMessage="We use only necessary cookies, they are required for our website to work properly. If you set your browser to block these, certain parts of our website won't work. "
                values={{
                  use: (
                    <a href={URL_USE} target="_blank" rel="noopener noreferrer">
                      {' '}
                      <FormattedMessage
                        id="Index.use"
                        defaultMessage="Term of use"
                      />
                      {' '}
                    </a>
                  ),
                  rule: (
                    <a
                      href={URL_RULE}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {' '}
                      <FormattedMessage
                        id="Index.rule"
                        defaultMessage="Privacy notice"
                      />
                      {' '}
                    </a>
                  ),
                }}
              />
              {/* <Button
          htmlType="button"
          type="primary"
          className="btn"
          onClick={this.handleClickOK}
        >
          <FormattedMessage id="app.btn.ok" defaultMessage="ok" />
        </Button> */}
              <Button
                htmlType="button"
                className="close"
                onClick={this.handleClickClose}
              >
                close
              </Button>
            </div>
          )}
        </div>
        <Content className="content">
          <Routes routes={routes} />
        </Content>
        {ifEmptyFooterHeader && (
        <Footer className="footer">
          <MyFooter />
        </Footer>
        )}
      </Layout>
    );
  }
}

App.propTypes = {
  auth: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  handleLogout: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  routes: PropTypes.array.isRequired,
  ui: PropTypes.shape({
    uiHeader: PropTypes.object.isRequired,
    cookieVisibility: PropTypes.bool.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default CompWrapper(App, 'page_index');
